import { TranslateDefaultParser } from '@ngx-translate/core';
import { isEmpty, get, isNil } from 'lodash';

import { generateMessage } from '@app/text-content/messages';

import { environment } from '../../../../environments/environment';

export class DefaultTranslationParser extends TranslateDefaultParser {
  /**
   * Override the interpolate method to handle default translations
   * with custom interpolation logic.
   *
   * @param translation
   * @param params
   * @return interpolated translation string
   */
  public interpolate(
    translation: string | Function,
    params: Record<string, any>,
  ): string {
    if (isEmpty(translation) || typeof translation !== 'string') {
      return super.interpolate(translation, params);
    }

    // Custom logic to handle default translations
    // use the generateMessage function to interpolate the translation
    return generateMessage(translation, params);
  }

  public getValue(target: any, key: string) {
    // Custom logic for translation can be added here
    let targetStr = key;

    try {
      targetStr = isEmpty(key) ? key : super.getValue(target, key);
    } catch (error) {
      console.error('Translation error when get value:', error);

      return targetStr;
    }

    // If the targetStr is nil, return it and to trigger missing translation handler
    if (isNil(targetStr)) {
      return targetStr;
    }

    const isEnableSpecialTranslationSymbol =
      get(environment, 'ENABLE_SPECIAL_TRANSLATION_SYMBOL', 'false') === 'true';

    return isEnableSpecialTranslationSymbol ? `#${targetStr}#` : targetStr;
  }
}
